import React from 'react';

export const GetInvolvedPage = () => {
  const styles = {
    container: {
      backgroundColor: "#d7ffd9",
      color: "#1b5e20",
      minHeight: "100vh",
      padding: "60px 30px",
      paddingTop: "120px",
    },
    card: {
      backgroundColor: "white",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      padding: "50px 60px",
      maxWidth: "900px",
      margin: "0 auto",
    },
    heading: {
      fontSize: "2.25rem",
      color: "#1b5e20",
      fontWeight: "bold",
      marginBottom: "30px",
      lineHeight: "1.3",
    },
    paragraph: {
      fontSize: "1.15rem",
      lineHeight: "1.8",
      color: "#2e7d32",
      marginBottom: "20px",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.heading}>The Inspiration Behind MedConnect</h1>
        <p style={styles.paragraph}>
          As students pursuing careers in healthcare, we experienced firsthand the challenges of navigating the pre-health path at a rural institution. Limited access to mentorship, clinical exposure, and professional networks often made the journey feel isolating and overwhelming.
        </p>
        <p style={styles.paragraph}>
          We recognized that talent and ambition should never be limited by geography. MedConnect was created to bridge that gap by building structured pathways to mentorship, experiential learning, and meaningful professional connections.
        </p>
        <p style={styles.paragraph}>
          Our goal is simple but powerful: to ensure that every pre-health student, regardless of location, has equitable access to the guidance and opportunities needed to confidently pursue a career in medicine. MedConnect is proud to operate as an officially recognized 501(c)(3) nonprofit organization, expanding our ability to serve students nationwide.
        </p>
      </div>
    </div>
  );
};
